export default __webpack_public_path__ + "static/media/arrow-next-blue.84c9d86e.svg";